import React from 'react';
import PropTypes from 'prop-types';

import gridCalculator from './gridCalculator';

const Column = ({
  children,
  numberOfColumns = gridCalculator.MAX_NUMBER_OF_COLUMNS,
  autoWidth = false,
  defaultColumn = false,
  columnOffset = 0,
  alignItems = 'normal',
  alignSelf = 'auto',
  justifyContent = 'normal',
  extraStyles = {},
  innerRef = null,
}) => {
  const styles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: alignItems,
    alignSelf: alignSelf,
    justifyContent: justifyContent,
    ...extraStyles,
  };
  if (!autoWidth && !defaultColumn) {
    styles.width = gridCalculator.calculateColumnWidth(numberOfColumns);
    styles.marginLeft = columnOffset !== 0 ? gridCalculator.calculateColumnOffset(columnOffset) : 0;
  } else if (autoWidth) {
    styles.flexGrow = 1;
  }
  return (
    <div ref={innerRef} style={styles}>
      {children}
    </div>
  );
};

Column.propTypes = {
  alignItems: PropTypes.string,
  alignSelf: PropTypes.string,
  autoWidth: PropTypes.bool,
  children: PropTypes.node,
  columnOffset: PropTypes.number,
  defaultColumn: PropTypes.bool,
  extraStyles: PropTypes.object,
  innerRef: PropTypes.object,
  justifyContent: PropTypes.string,
  numberOfColumns: PropTypes.number,
};

export default React.forwardRef((props, ref) => <Column {...props} innerRef={ref} />);
